import * as React from 'react';

import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import Alert from '../data/Alert';
import Linkify from 'react-linkify';

interface Props {
  data: Alert;
}

export class AlertView extends React.Component<Props> {
  componentDidMount() {
    window.onpopstate = () => {
      storeDispatch(Actions.closeAllAlerts());
    };
  }
  componentWillUnmount(): void {
    window.onpopstate = null;
  }
  didClickOk = () => {
    storeDispatch(Actions.closeAlert());
    if (this.props.data.okCallback) {
      setTimeout(this.props.data.okCallback, 100); // is this needed?
    }
  };

  didClickCancel = () => {
    storeDispatch(Actions.closeAlert());
    if (this.props.data.cancelCallback) {
      setTimeout(this.props.data.cancelCallback, 100); // is this needed?
    }
  };

  render() {
    let paragraphs: string[];
    if (Array.isArray(this.props.data.text)) {
      paragraphs = this.props.data.text;
    } else {
      paragraphs = [this.props.data.text];
    }
    return (
      <div className="alert">
        <div className="content">
          <h1>{this.props.data.title}</h1>
          <p>
            {paragraphs.map((text, index) => {
              return (
                <Linkify component="span" target="_blank" key={index}>
                  {text}
                  {index < paragraphs.length - 1 && <br />}
                </Linkify>
              );
            })}
          </p>
          <div className="buttons">
            {this.props.data.cancelButton && (
              <button className="large secondary" onClick={this.didClickCancel}>
                {this.props.data.cancelButton}
              </button>
            )}
            <button className="large primary" onClick={this.didClickOk}>
              {this.props.data.okButton || 'Ok'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AlertView.tsx